<template>
  <div>
    <div class="page">
      <el-collapse v-model="activeNames" class="collapse-main-content">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              电价信息
            </div>
          </template>
          <div class="collapse-content">
            <sirui-search
              :query="baseFormData"
              :columns="formColumn"
              :isQueryPanel="false"
            ></sirui-search>
            <vxe-table
              :data="detail"
              border
              align="center"
              header-align="center"
              style="margin-top: 20px; margin-bottom: 20px; width: 100%"
            >
              <vxe-table-column field="seq" type="seq" title="序号"> </vxe-table-column>
              <vxe-table-column field="spaceAssetName" title="资产"></vxe-table-column>
              <vxe-table-column field="spaceUnitName" title="单元"></vxe-table-column>
              <vxe-table-column field="spaceFloorName" title="楼层"></vxe-table-column>
              <vxe-table-column field="spaceRoomName" title="房号"></vxe-table-column>
            </vxe-table>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              {{ type == 'approval' ? '审批信息' : '审核记录' }}
            </div>
          </template>
          <div class="collapse-content">
            <el-form :rules="rules" ref="form" :model="form" v-if="type == 'approval'">
              <el-form-item label="审批信息：" prop="approvalInformation" style="margin-left: 20px">
                <el-input
                  v-model="form.approvalInformation"
                  placeholder="请输入"
                  type="textarea"
                  :rows="4"
                  style="width: 90%"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <vxe-table
              v-else
              :data="auditRecords"
              border
              align="center"
              header-align="center"
              style="margin-top: 20px; margin-bottom: 20px; width: 100%"
            >
              <vxe-table-column field="seq" type="seq" title="序号"></vxe-table-column>
              <vxe-table-column field="optUserName" title="操作人"></vxe-table-column>
              <vxe-table-column field="optType" title="操作"></vxe-table-column>
              <vxe-table-column field="optTime" title="操作时间"></vxe-table-column>
              <vxe-table-column field="info" title="审批信息"></vxe-table-column>
            </vxe-table>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- 底部按钮 fixme需要判断立项状态显示-->
    <footer class="bottomButtons">
      <div style="padding: 20px; background: #fff" v-if="type == 'approval'">
        <el-row class="page-row">
          <el-button type="primary" @click="adoptClick">通过</el-button>
          <el-button type="primary" @click="rejectClick">驳回</el-button>
          <el-button type="primary" @click="cancelClick" plain>取消</el-button>
        </el-row>
      </div>
    </footer>
  </div>
</template>
<script>
  import API from '@/api/property/meterManagement';
  import { detailColumn } from './columns/columns.js';
  export default {
    name: 'PriceSettingDetail',
    computed: {
      formColumn() {
        return detailColumn(this);
      },
    },
    data() {
      return {
        activeNames: ['1', '2'],
        baseFormData: {},
        detail: [],
        form: {
          approvalInformation: '',
        },

        rules: {
          approvalInformation: [
            { required: true, message: '审批信息', trigger: 'blur' },
            { min: 2, max: 50, message: '请输入2-50个字符', trigger: 'blur' },
          ],
        },
        type: '',

        auditRecords: [],
      };
    },
    mounted() {
      this.type = this.$route.query.type;
      this.getDetail();
      //请求数据
    },
    methods: {
      // 电表详情
      async getDetail() {
        const { data } = await this.$axios.get(`${API.PRICE_DETAILE}/${this.$route.query.id}`);
        if (data.code == 0) {
          this.baseFormData = data.data;
          this.baseFormData.spaceAreaName = this.baseFormData.spaces[0].spaceAreaName;
          if (data.data.servicePrice != null) {
            this.baseFormData.servicePrice = data.data.servicePrice.toString();
          }
          if (data.data.price != null) {
            this.baseFormData.price = data.data.price.toString();
          }
          this.detail = this.baseFormData.spaces;
          this.auditRecords = this.baseFormData.record;
        }
      },
      adoptClick() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.adoptPost();
          }
        });
      },
      async adoptPost() {
        const { data } = await this.$axios.post(
          `${API.PRICE_PASS}/${this.$route.query.id}/pass?info=${this.form.approvalInformation}`
        );
        if (data.code == 0) {
          this.$message.success('审核成功');
          this.returnPath();
        } else {
          if (data.msg != '') {
            return this.$message.error(data.msg);
          }
          this.$message.error('操作失败');
        }
      },
      async rejectClick() {
        const { data } = await this.$axios.post(
          `${API.PRICE_PASS}/${this.$route.query.id}/reject?info=${this.form.approvalInformation}`,
          { info: this.form.approvalInformation }
        );
        if (data.code == 0) {
          this.returnPath();
          this.$message.success('操作成功');
        } else {
          if (data.msg != '') {
            return this.$message.error(data.msg);
          }
          this.$message.error('操作失败');
        }
      },
      cancelClick() {
        this.returnPath();
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: false },
          },
          toPath: {
            path: '/property/priceSetting',
            name: 'priceSetting',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .page {
    background-color: white;
    margin-top: 0px;
    padding: 20px;
    height: 100%;
    top: 0;

    .title {
      font-size: 20px;
      color: black;
      margin-left: 10px;
      margin-bottom: 10px;
      font-weight: bolder;
    }
  }

  .bottomButtons {
    margin-top: 20px;
  }
</style>
